import async from '~/utils/async';
import RootStoreContext from '~/contexts/RootStoreContext';
import resolver from './ClientApplicationListLayout.resolver';
import ClientApplicationListLayout from './ClientApplicationListLayout';

export default async(resolver, { context: RootStoreContext })(
  ClientApplicationListLayout
);
